import { t } from '@life/i18n';
import type { Game } from '../state/game';
import { applyTheme, resolveTheme, THEME_PREFS, type ThemePref } from '../theme';

/** Выбор темы: система / светлая / тёмная → `data-theme` на <html> и settings.theme. */
export function ThemeToggle({ game }: { game: Game }) {
  const current = game.settings.value.theme;
  const choose = (theme: ThemePref) => {
    game.settings.value = { ...game.settings.value, theme };
    applyTheme(resolveTheme(theme));
  };
  return (
    <fieldset class="radios compact theme" aria-label={t('ui.theme.label')}>
      {THEME_PREFS.map((pref) => (
        <label key={pref}>
          <input type="radio" name="theme" value={pref} checked={current === pref} onChange={() => choose(pref)} />
          {t(`ui.theme.${pref}`)}
        </label>
      ))}
    </fieldset>
  );
}
